import type { Dispatch, FC, SetStateAction } from "react";
import React, { createContext, useContext, useState } from "react";
import { IsSignUp } from "@commercekit/shared";

const CheckoutSignUpCtx = createContext<{
  isSignup: IsSignUp;
  setIsSignup: Dispatch<SetStateAction<IsSignUp>>;
}>({
  isSignup: IsSignUp.NO,
  setIsSignup: () => {},
});

export const CheckoutSignUpCtxProvider: FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const [isSignup, setIsSignup] = useState(IsSignUp.NO);

  return (
    <CheckoutSignUpCtx.Provider
      value={{
        isSignup,
        setIsSignup,
      }}
    >
      {children}
    </CheckoutSignUpCtx.Provider>
  );
};

export const useCheckoutSignup = () => useContext(CheckoutSignUpCtx);
